import React from "react";
import { FiSmile, FiCloud, FiCoffee } from "react-icons/fi";

const ChatHome = ({ isOpen }) => {
  return (
    <div
      className={`fixed z-10 top-16 left-0 right-0 max-h-[500px] bg-transparent bg-opacity-5 flex justify-center items-center transition-transform duration-300 transform ${
        isOpen ? "translate-x-0 md:translate-x-1/3" : "translate-x-0"
      }`}
      style={{ marginRight: isOpen ? "calc(100vw - 70%)" : 0 }}
    >
      <div className="p-4 m-6 rounded w-full max-w-4xl">
        {/* Main content */}
        <div className="flex-1 flex flex-col items-center justify-center text-white p-3">
          <div className="text-center mb-8">
            <img
              src="robot chatbot.png"
              alt="Gemini"
              className="w-32 h-50 mx-auto"
            />
            <div className="text-sm text-gray-400">Powered by Gemini</div>
          </div>
          {/* Main content */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            {/* Tell me a joke */}
            <div className="bg-slate-200 dark:bg-slate-900 p-4 rounded-lg text-center max-w-xs" style={{ width: '200px' }}>
              <div className="flex justify-center items-center mb-2">
                <FiSmile className="text-slate-300 text-2xl" />
              </div>
              <div className="text-lg sm:text-base">Tell me a joke</div>
            </div>
            {/* What is the recipe */}
            <div className="bg-slate-200 dark:bg-slate-900 p-3 rounded-lg text-center max-w-xs" style={{ width: '200px' }}>
              <div className="flex justify-center items-center mb-2">
                <FiCoffee className="text-slate-300 text-2xl" />
              </div>
              <div className="text-lg sm:text-base">
                What is the recipe of Butter Chicken?
              </div>
            </div>
            {/* Will it rain today */}
            <div className="bg-slate-200 dark:bg-slate-900 p-4 rounded-lg text-center max-w-xs hidden sm:block" style={{ width: '200px' }}>
              <div className="flex justify-center items-center mb-2">
                <FiCloud className="text-slate-300 text-2xl" />
              </div>
              <div className="text-lg sm:text-base">Will it rain today?</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatHome;
